module.exports = __webpack_public_path__ + "media/1.325be4ff.mp3";